namespace TabAurous.ECommerce {
    export interface ReceiptDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        OrderId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: number;
        RefNo?: string;
        TaxId?: number;
        TaxName?: string;
        TaxAmount?: number;
        BankId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'ECommerce.ReceiptDetails';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            OrderId = "OrderId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            RefNo = "RefNo",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxAmount = "TaxAmount",
            BankId = "BankId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
